import { render, staticRenderFns } from "./againLogin.vue?vue&type=template&id=b42fd28c&scoped=true&"
import script from "./againLogin.vue?vue&type=script&lang=js&"
export * from "./againLogin.vue?vue&type=script&lang=js&"
import style0 from "./againLogin.vue?vue&type=style&index=0&id=b42fd28c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42fd28c",
  null
  
)

export default component.exports